<template>
  <b-modal ref="detailed-flight-modal-ref" hide-footer hide-header>
    <div class="vtd-modal-content">
      <div class="vtd-modal-header mt-4">
        <h5 class="vtd-modal-title">Detailed Flight Information</h5>
        <button @click="closeModal" type="button" class="close" aria-label="Close">
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>

      <div class="vtd-modal-body">

        <div v-if="formattedFlights">
          <span v-for="(trip, i) in formattedFlights" :key="i" >
            <section v-if="trip && (trip.passengers || trip.recordLocators)" class="flights">
              <hr class="seperator" />
              <h3>Ticket {{ i + 1 }}</h3>
              <div class="flights-for">
                <div v-if="trip && trip.passengers && trip.passengers.length">
                  <h4>Itinerary for:</h4>
                  <ul >
                    <li v-for="(passenger, k) in trip.passengers" :key="k">
                      {{ passenger }}
                    </li>
                  </ul>
                </div>
                <div class="flights-for-ref">
                  <h4>Airline reference:</h4>
                  <ul v-if="trip.recordLocators && trip.recordLocators.length">
                    <li v-for="(record, l) in [...new Set(trip.recordLocators)]" :key="l">
                      {{ record }}
                    </li>
                  </ul>
                  <p v-else class="flight-unavailable-notice">Not available</p>
                </div>
              </div>

              <p v-if="trip.hasError" class="flight-unavailable-notice">
                Detailed flight information is not available for this booking.
              </p>

              <template v-if="!trip.hasError">
              <div v-for="(flight, fIndex) in trip.flights" :key="fIndex">
                <div class="flight-title-container">
                  <div :id="flight && flight.flightNumber && flight.flightNumber.length === 2
                      ? flight.airlineCode + 0 + flight.flightNumber
                      : flight.airlineCode + flight.flightNumber
                    " class="flight-title" style="scroll-margin-top: 50px">
                    <span><i class="material-icons mr-3"></i></span>{{ flight.departure.date }} | {{ flight.airlineName
                    }} | Flight
                    {{ flight.airline }} {{ flight.flightNumber }} |
                    {{ flight.aircraftType }}
                  </div>
                </div>
                <div class="flight-details">
                  <div class="flight-details-item">
                    <div class="flight-details-icon">
                      <i class="material-icons"></i>
                    </div>
                    <p class="flight-details-lead">{{ flight.departure.time }}</p>
                    <p class="flight-details-sub mb-3">{{ flight.departure.date }}</p>
                    <p>{{ flight.departure.airport.airportName }}</p>
                    <p>
                      ({{ flight.departure.airport.code }})
                    </p>
                    <p v-if="flight.departure.airport.terminal" class="flight-details-sub">Terminal {{
                      flight.departure.airport.terminal }}</p>

                  </div>
                  <div class="flight-details-item">
                    <p class="flight-details-sub">{{ flight.airlineName }}</p>
                    <p class="flight-details-lead">
                      {{ flight.airline }} {{ flight.flightNumber }}
                    </p>
                    <p>Journey Time: {{ flight.journeyTime }}</p>
                    <p>
                      Status: {{ flight.status }},
                      {{ flight.ticketNumber }} seats
                    </p>
                    <p v-if="flight.seats">{{ flight.seats }}</p>
                    <p class="mt-2" v-if="flight.touchdown">
                      Please note this flight touches down at {{ titleCase(flight.touchdown) }}.
                    </p>
                  </div>
                  <div class="flight-details-item">
                    <div class="flight-details-icon">
                      <i class="material-icons depart"></i>
                    </div>
                    <p class="flight-details-lead">
                      {{ flight.arrival.time }}
                    </p>
                    <p class="flight-details-sub mb-3">
                      {{ flight.arrival.date }}
                    </p>
                    <p>{{ flight.arrival.airport.airportName }}</p>
                    <p>({{ flight.arrival.airport.code }})</p>
                    <p class="flight-details-sub" v-if="flight.arrival.airport.terminal">
                      Terminal {{ flight.arrival.airport.terminal }}
                    </p>
                  </div>
                </div>
              </div>
              </template>
            </section>
          </span>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data(){
    return {
      formattedFlights: [],
    }
  },
  computed: {
    ...mapGetters({
      flights: "flights/getFlights",
      booking: "booking/getBooking",
    }),
  },
  watch: {
    flights(){
      this.checkForTouchdownFlights()
    }
  },
  mounted(){
    if (this.flights){
      this.checkForTouchdownFlights();
    }
  },
  methods: {
    async showModal(flightno) {
      this.$refs["detailed-flight-modal-ref"].show();
    },
    closeModal() {
      this.$refs["detailed-flight-modal-ref"].hide();
    },
    checkForTouchdownFlights() {
      let _flights = this.flights.filter(flight => Array.isArray(flight.flights));
      const { touchdownFlights } = this.booking;
      if (touchdownFlights && touchdownFlights.length) {
        _flights = this.flights.map((flight) => {
          const nestedFlightsArr = flight.flights.map((nestedFlight) => {
            const matchingFlight = this.findMatchingFlight(nestedFlight);
            if (matchingFlight && matchingFlight.expanderItems) {
              const touchdown = matchingFlight.expanderItems.find(
                (expandItem) => {
                  return expandItem.slug === "viacity";
                }
              );
              if (touchdown && touchdown.notes) {
                nestedFlight.touchdown = touchdown.notes;
              }
            }
            return nestedFlight;
          });
          flight.flights = nestedFlightsArr;
          return flight;
        });
      }
      this.formattedFlights = _flights;
    },
    findMatchingFlight(flt) {
      const matching = this.booking.touchdownFlights.find((_flight) => {
        return (
          _flight.vendorloc === flt.controlNumber &&
          flt.departure &&
          flt.departure.airport &&
          flt.departure.airport.code === _flight.citycodefrom &&
          flt.departure.time === _flight.deptime
        );
      });
      return matching;
    },
    titleCase(str){
      return str.split(" ").map(substring => substring.slice(0,1 ).toUpperCase() + substring.slice(1).toLowerCase()).join(" ")
    }
  },
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
